import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgValidationCheckBold16 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M3.66675 8.29486C4.8399 9.09787 6.91643 11.4693 7.56888 13C8.5601 9.59975 11.1322 4.7064 12.4497 3" stroke="currentColor" strokeWidth={2} strokeLinecap="square" /></svg>;
const ForwardRef = forwardRef(SvgValidationCheckBold16);
export default ForwardRef;